import type { FC, ReactNode } from 'react'

import { LegalPage, LegalSection } from '@/components/legal/legal-page'
import { siteConfig } from '@/constants/site'

const PrivacyPolicy: FC = (): ReactNode => {
    const { legal, contact } = siteConfig

    return (
        <LegalPage
            title='Política de privacidad'
            description='Cómo trata Jeme los datos personales que nos facilitas a través de este sitio web.'
            intro={(
                <p>
                    Esta política explica cómo tratamos los datos personales que nos facilitas a través de este sitio web, de acuerdo con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales.
                </p>
            )}
        >
            <LegalSection title='1. Responsable del tratamiento'>
                <ul>
                    <li>Titular: {legal.owner}</li>
                    <li>NIF: {legal.taxId}</li>
                    <li>Domicilio: {legal.address}</li>
                    <li>
                        Correo electrónico: <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </li>
                </ul>
            </LegalSection>

            <LegalSection title='2. Qué datos tratamos'>
                <p>
                    Los que introduces en el formulario de contacto: nombre, correo electrónico, perfil y, si decides indicarlos, teléfono, nombre del taller o desguace y el contenido de tu mensaje.
                </p>
            </LegalSection>

            <LegalSection title='3. Para qué los usamos'>
                <p>
                    Para responder a tu solicitud de información y explicarte cómo funciona Jeme. No usamos tus datos para enviarte comunicaciones comerciales sin tu consentimiento.
                </p>
            </LegalSection>

            <LegalSection title='4. Base legal'>
                <p>
                    Tu consentimiento, que nos das al marcar la casilla del formulario antes de enviarlo. Puedes retirarlo en cualquier momento escribiéndonos.
                </p>
            </LegalSection>

            <LegalSection title='5. Cuánto tiempo los conservamos'>
                <p>
                    Mientras sea necesario para atender tu solicitud y, después, durante los plazos que exija la ley.
                </p>
            </LegalSection>

            <LegalSection title='6. Con quién los compartimos'>
                <p>
                    No cedemos tus datos a terceros salvo obligación legal. Contamos con proveedores tecnológicos que alojan este sitio web y gestionan el envío de correos, y que tratan los datos únicamente siguiendo nuestras instrucciones.
                </p>
            </LegalSection>

            <LegalSection title='7. Estadísticas de visitas'>
                <p>
                    Este sitio web usa un sistema de analítica que no instala cookies ni recoge datos que te identifiquen. Solo genera estadísticas agregadas sobre el uso de la web.
                </p>
            </LegalSection>

            <LegalSection title='8. Tus derechos'>
                <p>
                    Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a <a href={`mailto:${contact.email}`}>{contact.email}</a>.
                </p>

                <p>
                    Si consideras que no hemos atendido correctamente tu solicitud, puedes presentar una reclamación ante la Agencia Española de Protección de Datos en <a href='https://www.aepd.es' target='_blank' rel='noopener noreferrer'>www.aepd.es</a>.
                </p>
            </LegalSection>
        </LegalPage>
    )
}

export default PrivacyPolicy
